import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BackOfficeLayout from "../../../components/backoffice-layout";
import CoreAPI from "../../../services/core";
import LoadingModal from "../../../components/loading-modal";
import { onSleep, validatePassword } from "../../../utils/default";
import InputComponent from "../../../components/evaluation-form-components/input";
import ButtonComponent from "../../../components/button";
import SuccessModal from "../../../components/modal/success";
import ConfirmModal from "../../../components/modal/confirm";

const Container = styled.div`
    width: calc(100% - 32px);
    background-color: #FFFFFF;
    padding: 40px 16px;
    border-radius: 16px;

    .label-header-info {
        color: #2A2A2A;
        font-size: 20px;
        font-weight: 500;
        line-height: 29.9px;
        text-align: left;
        margin-bottom: 20px;
    }

    .footer-bar {
        width: 100%;

        .button-box {
            width: fit-content;
            display: flex;
            gap: 16px;
            margin-right: 0px;
            margin-left: auto;
        }
    }

    .reset-label {
        width: fit-content;
        border-width: 0px 0px 2px 0px;
        border-style: solid;
        border-color: #25368D;
        color: #25368D;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
        cursor: pointer;
    }
`;

const LabelBox = styled.div`
    width: calc(50% - 8px);
    margin-bottom: 16px;

    &.last {
        margin-bottom: 0px;
    }

    .topic {
        color: #505050;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
        margin-bottom: 8px;
    }

    .label {
        color: #25368D;
        font-size: 15px;
        font-weight: 500;
        line-height: 22.43px;
        text-align: left;
    }

    .line {
        width: 100%;
        height: 1px;
        background-color: #A2A1A81A;
        margin-top: 8px;
    }
`;


function AccountPage() {
    const [isLoading, setIsLoading] = useState(false);
    const [isChangePassword, setIsChangePassword] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [detailModal, setDetailModal] = useState({
        title: "",
        sub_title: "",
        type: "",
        button_label: "ตกลง",
    });
    const [openConfirmModal, setOpenConfirmModal] = useState(false);

    const [profileDetail, setProfileDetail] = useState({
        user_username: "",
        user_firstname: "",
        user_lastname: "",
        department_department_name: "",
        division_division_name: "",
    })
    const [disableSave, setDisableSave] = useState(true);
    const [isError, setIsError] = useState(false);
    const [labelError, setLabelError] = useState("");
    const [passwordDetail, setPasswordDetail] = useState({
        old_password: "",
        new_password: "",
        confirm_password: "",
    })

    useEffect(() => {
        onInit();
    }, [])

    async function onInit() {
        setIsLoading(true);
        let profile = await onGetProfile();
        if (profile) {
            localStorage.setItem("profile", JSON.stringify(profile));
            setProfileDetail(profile)
        }
        await onSleep(500)
        setIsLoading(false);
    }
    async function onGetProfile() {
        let response = null;
        try {
            response = await CoreAPI.authenHttpService.getProfile();
        } catch { }
        return response
    }
    async function onChangePassword() {
        let response = null;
        try {
            const body = {
                ...passwordDetail
            }
            response = await CoreAPI.userHttpService.userChangePassword(body);
        } catch { }
        return response
    }

    function handleChangeInformation(key, value) {
        let detail = { ...passwordDetail };
        let disable = true;
        if (detail.old_password && detail.new_password && detail.confirm_password) {
            disable = false;
        }
        detail[key] = value;
        setPasswordDetail(detail)
        setDisableSave(disable)
        setIsError(false)
        setLabelError("")
    }
    function handleBack() {
        let detail = { ...passwordDetail };
        detail.old_password = "";
        detail.new_password = "";
        detail.confirm_password = "";
        setPasswordDetail(detail)
        setDisableSave(true)
        setIsChangePassword(false)
        setIsError(false)
        setLabelError("")
    }
    function handleConfirm() {
        if (passwordDetail.new_password !== passwordDetail.confirm_password) {
            setIsError(true)
            setLabelError("รหัสผ่านใหม่และการยืนยันรหัสผ่านใหม่ไม่ตรงกัน กรุณาตรวจสอบและลองอีกครั้ง")
            return;
        }
        if (!validatePassword(passwordDetail.new_password)) {
            setIsError(true)
            setLabelError("รหัสผ่านต้อง 8 ตัวอักษรขึ้นไป และมีทั้งตัวอักษร กับตัวเลข")
            return;
        }
        setOpenConfirmModal(true)
    }
    async function handleConfirmModal() {
        setIsLoading(true)
        setOpenConfirmModal(false)
        const response = await onChangePassword();
        let _detailModal = { ...detailModal }
        _detailModal.title = response?.success ? "เปลี่ยนรหัสผ่านสำเร็จ" : "เปลี่ยนรหัสผ่านล้มเหลว";
        _detailModal.sub_title = "";
        _detailModal.button_label = "ตกลง";
        _detailModal.type = response?.success ? "success" : "fail";
        _detailModal.from = "reset";

        setDetailModal(_detailModal)
        setOpenModal(true)
        setIsLoading(false)

        if (response?.success) {
            handleBack();
        }
    }

    return (
        <BackOfficeLayout>
            <LoadingModal open={isLoading} />
            <SuccessModal
                open={openModal}
                onConfirm={(e) => setOpenModal(false)}
                title={detailModal.title}
                subTitle={detailModal.sub_title}
                type={detailModal.type}
                buttonLabel={detailModal.button_label}
            />
            <ConfirmModal
                open={openConfirmModal}
                title={"ยืนยันการเปลี่ยนรหัสผ่าน"}
                labelBack={"ยกเลิก"}
                labelConfirm={"ยืนยัน"}
                onBack={(e) => setOpenConfirmModal(false)}
                onConfirm={handleConfirmModal}
            />
            <Container>
                <div className="label-header-info">ข้อมูลผู้ใช้งาน</div>
                <LabelBox>
                    <div className="topic">Username</div>
                    <div className="label">{profileDetail.user_username || "-"}</div>
                    <div className="line"></div>
                </LabelBox>
                <div className="vertical-center" style={{ gap: "16px" }}>
                    <LabelBox>
                        <div className="topic">ชื่อ</div>
                        <div className="label">{profileDetail.user_firstname || "-"}</div>
                        <div className="line"></div>
                    </LabelBox>
                    <LabelBox>
                        <div className="topic">นามสกุล</div>
                        <div className="label">{profileDetail.user_lastname || "-"}</div>
                        <div className="line"></div>
                    </LabelBox>
                </div>
                <div className="vertical-center" style={{ gap: "16px", marginBottom: "20px" }}>
                    <LabelBox className="last">
                        <div className="topic">ฝ่าย</div>
                        <div className="label">{profileDetail.department_department_name || "-"}</div>
                    </LabelBox>
                    <LabelBox className="last">
                        <div className="topic">กอง</div>
                        <div className="label">{profileDetail.division_division_name || "-"}</div>
                    </LabelBox>
                </div>
                {isChangePassword ?
                    <>
                        <div className="label-header-info">เปลี่ยนรหัสผ่าน</div>
                        <InputComponent
                            label={"รหัสผ่านเดิม"}
                            placeholder={"กรุณากรอกรหัสผ่านเดิม"}
                            styleInput={{ border: "1px solid #B5B5B5" }}
                            type={"password"}
                            value={passwordDetail.old_password}
                            onInput={(e) => { handleChangeInformation("old_password", e) }}
                        />
                        <InputComponent
                            label={"รหัสผ่านใหม่"}
                            placeholder={"กรุณากรอกรหัสผ่านใหม่"}
                            styleInput={{ border: "1px solid #B5B5B5" }}
                            type={"password"}
                            value={passwordDetail.new_password}
                            isError={isError}
                            labelError={labelError}
                            onInput={(e) => { handleChangeInformation("new_password", e) }}
                        />
                        <InputComponent
                            label={"ยืนยันรหัสผ่านใหม่"}
                            placeholder={"กรุณากรอกรหัสผ่านใหม่อีกครั้ง"}
                            styleInput={{ border: "1px solid #B5B5B5" }}
                            type={"password"}
                            value={passwordDetail.confirm_password}
                            isError={isError}
                            labelError={labelError}
                            onInput={(e) => { handleChangeInformation("confirm_password", e) }}
                        />
                        <div className="footer-bar">
                            <div className="button-box">
                                <ButtonComponent
                                    label={"ยกเลิก"}
                                    variant={"secondary"}
                                    sceenSize={"lg"}
                                    style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                                    onClick={handleBack}
                                />
                                <ButtonComponent
                                    disable={disableSave}
                                    label={"ยืนยัน"}
                                    variant={"primary"}
                                    sceenSize={"lg"}
                                    style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                                    onClick={handleConfirm}
                                />
                            </div>
                        </div>
                    </>
                    :
                    <div className="reset-label"
                        onClick={(e) => setIsChangePassword(true)}
                    >
                        เปลี่ยนรหัสผ่าน
                    </div>
                }
            </Container>
        </BackOfficeLayout>
    )
}

export default AccountPage;